"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/** The list that the types of dialogue policy. */
exports.default = Object.freeze(['fix', 'flex']);
//# sourceMappingURL=communication.js.map